const state = {
  showReplayQueue: false
}

const getters = {
  getShowReplayQueue: state => state.showReplayQueue
}

const mutations = {
  'SHOW_REPLAY_QUEUE_POPUP': (state, showReplayQueue) => { state.showReplayQueue = showReplayQueue }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
